import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import axios from 'axios';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import Swal from 'sweetalert2';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseurl } from '../utility/helper';
import generateCertificatePDF from './generateCertificatePDF';

const PriorEvidence = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [ongoingTests,           setOngoingTests]           = useState([]);
  const [completedTests,         setCompletedTests]         = useState([]);
  const [passedNotJoinedTests,   setPassedNotJoinedTests]   = useState([]);   // ── NEW
  const [selectedCandidates,     setSelectedCandidates]     = useState([]);
  const [selectedJoinCandidates, setSelectedJoinCandidates] = useState([]);   // ── NEW

  const ongoingRef        = useRef(null);
  const completedRef      = useRef(null);
  const passedNotJoinedRef = useRef(null);                                    // ── NEW
  const navigate          = useNavigate();

  // ─────────────────────────────────────────────────────────────────────────
  // Fetch data
  // ─────────────────────────────────────────────────────────────────────────
  const fetchPriorevidence = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      const response = await fetch(`${baseurl}/admin/priorevidence`, {
        method: 'GET',
        headers: { 'Authorization': `${token}`, 'Content-Type': 'application/json' }
      });

      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();

      const ongoing = data.ongoing.map(test => ({
        ...test,
        prior_evidence_date_time_raw: test.prior_evidence_date_time,
        prior_evidence_date_time: formatDateTime(test.prior_evidence_date_time),
      }));

      const completed = data.complete.map(test => ({
        ...test,
        prior_evidence_date_time: formatDateTime(test.prior_evidence_date_time),
      }));

      const passnotjoin = data.passnotjoin.map(test => ({
        ...test,
        prior_evidence_date_time: formatDateTime(test.prior_evidence_date_time),
      }));

      setOngoingTests(ongoing);
      setCompletedTests(completed);
      setPassedNotJoinedTests(passnotjoin);
    } catch (error) {
      console.error('Error fetching prior evidence:', error);
    }
  };

  useEffect(() => {
    fetchPriorevidence();
  }, []);

  // ─────────────────────────────────────────────────────────────────────────
  // Send result mail (existing)
  // ─────────────────────────────────────────────────────────────────────────
  const handleSendMail = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to send mail to ${selectedCandidates.length} candidate(s)?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, send mail!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            `${baseurl}/admin/testcandidates/priorevidenceresult/send_email`,
            { prior_ids: selectedCandidates },
            {
              headers: {
                Authorization: sessionStorage.getItem("token"),
                'Content-Type': 'application/json'
              }
            }
          );

          console.log('Email Response:', response.data);
          Swal.fire('Sent!', 'Emails sent successfully.', 'success');

          setSelectedCandidates([]);
          $('.send-mail-checkbox').prop('checked', false);
          $('#selectAllSendMail').prop('checked', false);

          await fetchPriorevidence();
          renderTable(ongoingRef.current, ongoingTests, false);
          renderTable(completedRef.current, completedTests, true);
        } catch (err) {
          console.error('Error sending emails:', err);
          Swal.fire('Error!', 'Error sending emails. Check console.', 'error');
        }
      }
    });
  };

  // ── NEW: Send joining invitation mail ─────────────────────────────────────
  const handleSendJoiningMail = () => {
    if (!selectedJoinCandidates.length) return;

    Swal.fire({
      title: 'Send Joining Invitation?',
      text: `Send membership joining mail to ${selectedJoinCandidates.length} candidate(s)?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#198754',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, send!'
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        await axios.post(
          `${baseurl}/admin/candidates/send_joining_mail`,   // ← adjust endpoint to match your backend
          { ids: selectedJoinCandidates },
          {
            headers: {
              Authorization: sessionStorage.getItem('token'),
              'Content-Type': 'application/json'
            }
          }
        );

        Swal.fire('Sent!', 'Joining invitation emails sent successfully.', 'success');

        // Reset checkboxes
        setSelectedJoinCandidates([]);
        $('.joining-mail-checkbox').prop('checked', false);
        $('#selectAllJoiningMail').prop('checked', false);

        // Refresh passed-not-joined table
        await fetchPriorevidence();
      } catch (err) {
        console.error('Error sending joining mail:', err);
        Swal.fire('Error!', 'Could not send joining mails. Check console.', 'error');
      }
    });
  };

  // ─────────────────────────────────────────────────────────────────────────
  // Helpers
  // ─────────────────────────────────────────────────────────────────────────
  const formatDateTime = (timestamp) => {
    if (!timestamp) return '';
    const date    = new Date(timestamp);
    const istDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    const day     = istDate.getDate();
    const month   = String(istDate.getMonth() + 1).padStart(2, '0');
    const year    = istDate.getFullYear();
    let   hours   = istDate.getHours();
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    const ampm    = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };

  const handleViewCertificate = async (id) => {
    try {
      const token = sessionStorage.getItem("token");

      const response = await fetch(
        `${baseurl}/admin/priorevidence/certificate/view?id=${id}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        Swal.fire("Error", data.message, "error");
        return;
      }

      window.open(data.url, "_blank");

    } catch (err) {
      console.error(err);

      Swal.fire(
        "Error",
        "Failed to load certificate",
        "error"
      );
    }
  };
  
const handleViewPDF = async (id) => {
  try {
    const res = await axios.get(
      `${baseurl}/admin/priorevidence/download?id=${id}`,
      {
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/json"
        }
      }
    );

    if (!res.data.files || res.data.files.length === 0) {
      Swal.fire({ icon: "info", title: "No files found for this record." });
      return;
    }

    const listHtml = res.data.files.map((file, index) => `
      <div style="text-align:left; margin-bottom:8px;">
        <a href="${file.url}" download="${file.filename}" target="_blank" rel="noopener noreferrer">
          📄 File ${index + 1}: ${file.filename}
        </a>
      </div>
    `).join("");

    Swal.fire({
      title: "Prior Evidence Files",
      html: listHtml,
      confirmButtonText: "Close",
      width: 500,
    });
  } catch (err) {
    console.error(err);
    Swal.fire({ icon: "error", title: "Failed to download PDF" });
  }
};
  // ─────────────────────────────────────────────────────────────────────────
  // Render existing tables (ongoing / completed) — unchanged
  // ─────────────────────────────────────────────────────────────────────────
  const renderTable = (tableElement, tableData, isCompleted = false) => {
    if (!tableElement) return;

    if ($.fn.DataTable.isDataTable(tableElement)) {
      $(tableElement).DataTable().clear().destroy();
    }

    const table = $(tableElement).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
      buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'pdfHtml5', 'print'].map(btn => ({
        extend: btn,
        className: 'btn btn-primary dttable',
        exportOptions: {
          columns: ':visible',
          format: {
            body:   (data) => { if (data == null) return ''; return data.toString().replace(/<[^>]*>/g, '').trim(); },
            header: (data) => { if (!data) return ''; return data.toString().replace(/<[^>]*>/g, '').trim(); }
          }
        }
      })),
      data: tableData,
      columns: [
        { data: null, title: 'Sr.No' },
        {
            data: 'prior_evidence_candidate_id',
            title: 'ID',
            render: (data, type, row) => {
                const candidateId = row.prior_evidence_candidate_id;

                if (type !== "display") {
                    return candidateId || "";
                }

                if (!candidateId) {
                    return `<span class="cl-muted">—</span>`;
                }

                const url = `/admin/CandiAdd/${candidateId}`;

                return `
                    <a
                        href="${url}"
                        class="cl-id-link"
                        onclick="event.preventDefault(); window.open(this.href, '_blank');"
                    >
                        ${candidateId}
                    </a>
                `;
            }
        },
        { data: 'prior_evidence_date_time', title: 'Date' },
        { data: null, title: 'Name' },
        { data: 'mobile_no', title: 'Mobile No' },
        { data: 'email', title: 'Email' },
        { data: 'attachments', title: 'Document' },
        { data: null, title: 'Result' },
        { data: null, title: 'Generate' },
        { data: null, title: 'Certificate' },
        { data: 'certificate', title: 'View Certificate' },
        { data: null, title: 'Send Mail' },
      ],
      columnDefs: [
        { targets: 0, defaultContent: '', render: (data, type, row, meta) => meta.row + 1 },
        {
          targets: 2,
          render: function (data, type, row) {

            if (type === 'sort') {
              return new Date(row.prior_evidence_date_time_raw).getTime();
            }

            return data; // display formatted date
          }
        },
        { targets: 3, defaultContent: '', render: (data, type, row) => `${row.first_name || ''} ${row.last_name || ''}` },
        {
          targets: 6, defaultContent: '',
          render: (data, type, row) => {
            if (type !== 'display') return row.attachments || '';
            return `<button class="btn btn-primary view-pdf" data-id="${row.prior_evidence_registration_id}">View</button>`;
          }
        },
        {
          targets: 7, defaultContent: '',
          render: (data, type, row) => {
            if (type !== 'display') return row.result || '';
            // Always editable — result can be updated multiple times.
            return `<select class="form-select form-select-sm result-dropdown" data-id="${row.prior_evidence_registration_id}">
                      <option value="" ${!row.result ? 'selected' : ''}>Select</option>
                      <option value="Pass" ${row.result === 'Pass' ? 'selected' : ''}>Accepted</option>
                      <option value="Fail" ${row.result === 'Fail' ? 'selected' : ''}>Not Accepted</option>
                    </select>`;
          }
        },
        {
          targets: 8, defaultContent: '',
          render: (data, type, row) => {
            if (type !== 'display') return '';
            const hasResult = row.result && row.result !== '';
            const disabled  = hasResult ? '' : 'disabled title="Set result first"';
            return `<button class="btn btn-sm btn-primary generate-certificate"
                      data-id="${row.prior_evidence_registration_id}"
                      data-name="${row.first_name} ${row.last_name}"
                      data-testdate="${row.prior_evidence_date_time}"
                      data-result="${row.result || ''}"
                      ${disabled}>Generate Letter</button>`;
          }
        },
        {
          targets: 9, defaultContent: '',
          render: (data, type, row) => {
            if (type !== 'display') return '';
            return `<button class="btn btn-sm btn-primary upload-certificate"
                      data-id="${row.prior_evidence_registration_id}">Upload Certificate</button>`;
          }
        },
        {
          targets: 10,defaultContent: '',
          render: function (data, type, row) {
            return (row.has_certificate != false)
              ? `<button class="btn btn-success btn-sm view-btn" data-id="${row.prior_evidence_registration_id}">View</button>`
              : '<div style="text-align:center;color:gray;padding:4px 8px;border:1px solid #ccc;border-radius:4px;background:#f0f0f0;cursor:not-allowed;font-size:12px">Disabled</div>';
          }
        },
        {
          targets: 11, defaultContent: '', orderable: false,
          render: (data, type, row) => {
            if (type !== 'display') return '';
            if (isCompleted) return 'Completed';
            return `<input type="checkbox" class="send-mail-checkbox"
                      data-id="${row.prior_evidence_registration_id}"
                      data-email="${row.email}">`;
          }
        }
      ],
      order: [[0, 'asc']],
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
        if (!isCompleted) {
          const header = $(tableElement).find('thead tr th').eq(10);
          header.html('<input type="checkbox" id="selectAllSendMail"> Send Mail');
          $('#selectAllSendMail').on('change', function () {
            const checked = $(this).is(':checked');
            $('.send-mail-checkbox').prop('checked', checked).trigger('change');
          });
        }
      }
    });
  };

  // ── NEW: Render passed-not-joined DataTable ────────────────────────────────
  const renderPassedNotJoinedTable = (tableElement, tableData) => {
    if (!tableElement) return;

    if ($.fn.DataTable.isDataTable(tableElement)) {
      $(tableElement).DataTable().clear().destroy();
    }

    $(tableElement).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
      buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'pdfHtml5', 'print'].map(btn => ({
        extend: btn,
        className: 'btn btn-primary dttable',
        exportOptions: {
          columns: ':not(:last-child)',          // exclude checkbox column from export
          format: {
            body:   (data) => { if (data == null) return ''; return data.toString().replace(/<[^>]*>/g, '').trim(); },
            header: (data) => { if (!data) return ''; return data.toString().replace(/<[^>]*>/g, '').trim(); }
          }
        }
      })),
      data: tableData,
      columns: [
        { data: null,                       title: 'Sr.No'        },
        { data: 'prior_evidence_date_time', title: 'Date'    },
        { data: null,                       title: 'Name'         },
        { data: 'mobile_no',                title: 'Mobile No'    },
        { data: 'email',                    title: 'Email'        },
        { data: null,                       title: 'Result'       },
        { data: null,                       title: 'Send Joining Mail' },   // ← checkbox column
      ],
      columnDefs: [
        {
          // Sr. No
          targets: 0, defaultContent: '',
          render: (data, type, row, meta) => meta.row + 1,
        },
        {
          // Full name (clickable link to edit if needed)
          targets: 2, defaultContent: '',
          render: (data, type, row) => {
            if (type !== 'display') return `${row.first_name || ''} ${row.last_name || ''}`;
            return `<span style="font-weight:600">${row.first_name || ''} ${row.last_name || ''}</span>`;
          },
        },
        {
          // Result badge — always Pass for this table
          targets: 5, defaultContent: '',
          render: (data, type, row) => {
            if (type !== 'display') return row.prior_exam_result || 'Pass';
            return `<span class="badge bg-success px-2 py-1" style="font-size:12px">✓ Pass</span>`;
          },
        },
        {
          // Joining mail checkbox
          targets:6, defaultContent: '', orderable: false,
          render: (data, type, row) => {
            if (type !== 'display') return '';
            return `<div class="text-center">
                      <input
                        type="checkbox"
                        class="joining-mail-checkbox"
                        data-id="${row.test_candidate_id || row.pre_test_candidate_id || ''}"
                        data-email="${row.email || ''}"
                        style="width:16px;height:16px;cursor:pointer"
                      />
                    </div>`;
          },
        },
      ],
      order: [[0, 'asc']],
      // Highlight all rows amber — they are pending action
      rowCallback: function (row) {
        $(row).css('background-color', '#fffbeb');
      },
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');

        // "Select all" in the header
        const header = $(tableElement).find('thead tr th').eq(8);
        header.html(
          '<div class="text-center"><input type="checkbox" id="selectAllJoiningMail" style="width:15px;height:15px;cursor:pointer"> Send Joining Mail</div>'
        );

        $('#selectAllJoiningMail').on('change', function () {
          const checked = $(this).is(':checked');
          $('.joining-mail-checkbox').prop('checked', checked).trigger('change');
        });
      }
    });
  };

  // ─────────────────────────────────────────────────────────────────────────
  // useEffect — (re)render all tables when data changes
  // ─────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    renderTable(ongoingRef.current,   ongoingTests,   false);
    renderTable(completedRef.current, completedTests, true);

    // ── result-dropdown listener ─────────────────────────────────────────
    // ── CHANGE: after a successful update, re-pull fresh data from the
    //    server (fetchPriorevidence) instead of only patching local state —
    //    this keeps the Generate/Certificate columns, and the ongoing vs
    //    completed split, in sync with the backend immediately.
    $(document).off('change', '.result-dropdown').on('change', '.result-dropdown', async function () {
      const registrationId = $(this).data('id');
      const selectedResult = $(this).val();
      if (!selectedResult) return;

      const $select = $(this);
      $select.prop('disabled', true);

      try {
        const response = await axios.post(
          `${baseurl}/admin/priorevidence/update_result`,
          { registration_id: registrationId, result: selectedResult },
          { headers: { Authorization: sessionStorage.getItem('token') } }
        );
        console.log('Result updated:', response.data);

        // Pull fresh ongoing / completed / passed-not-joined lists so every
        // dependent column (Generate Letter enable state, etc.) is current.
        await fetchPriorevidence();

        Swal.fire({
          icon: 'success',
          title: 'Updated!',
          text: `Result set to ${selectedResult} successfully.`,
          timer: 1800,
          showConfirmButton: false,
        });
      } catch (err) {
        console.error('Error updating result:', err);
        $select.prop('disabled', false);
        Swal.fire('Error!', 'Could not update result. Check console.', 'error');
      }
    });

    // ── existing send-mail checkbox listener ─────────────────────────────
    $(document).off('change', '.send-mail-checkbox').on('change', '.send-mail-checkbox', function () {
      const candidateId = $(this).data('id');
      setSelectedCandidates(prev => {
        if ($(this).is(':checked')) {
          return prev.includes(candidateId) ? prev : [...prev, candidateId];
        }
        return prev.filter(id => id !== candidateId);
      });
    });

    // ── View Certificate ──────────────────────────────────────────────────────
    $(document).off('click', '.view-btn').on('click', '.view-btn', function () {
      const id = $(this).data('id');
      handleViewCertificate(id);
    });

    // ── NEW: joining-mail checkbox listener ──────────────────────────────
    $(document).off('change', '.joining-mail-checkbox').on('change', '.joining-mail-checkbox', function () {
      const candidateId = $(this).data('id');
      setSelectedJoinCandidates(prev => {
        if ($(this).is(':checked')) {
          return prev.includes(candidateId) ? prev : [...prev, candidateId];
        }
        return prev.filter(id => id !== candidateId);
      });
    });

    // ── View PDF ─────────────────────────────────────────────────────────
    $(document).on('click', '.view-pdf', function () {
      const id = $(this).data('id');
      handleViewPDF(id);
    });

    // ── Generate certificate ─────────────────────────────────────────────
    $(document).off('click', '.generate-certificate').on('click', '.generate-certificate', function () {
      const name     = $(this).data('name');
      const testDate = $(this).data('testdate');
      const result   = $(this).data('result');
      if (!result) {
        Swal.fire('Warning', 'Please set a result (Pass/Fail) before generating the letter.', 'warning');
        return;
      }
      generateCertificatePDF({ name, testDate, result });
    });

    // ── Upload certificate ────────────────────────────────────────────────
    // ── CHANGE: refresh data + give proper loading/success/error feedback
    //    (was: silent `alert()` with no table refresh, so "View Certificate"
    //    stayed disabled until a manual page reload).
    $(document).off('click', '.upload-certificate').on('click', '.upload-certificate', function () {
      const priorid = $(this).data('id');
      const $btn = $(this);
      const originalLabel = $btn.text();
      const input   = $('<input>').attr({ type: 'file', multiple: true });
      input.on('change', async function () {
        const files = this.files;
        if (!files.length) return;

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) formData.append('files', files[i]);

        $btn.prop('disabled', true).text('Uploading…');
        try {
          await axios.post(
            `${baseurl}/admin/priorevidence/upload_certificate?priorid=${priorid}`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );

          // Pull fresh data so "View Certificate" unlocks immediately and
          // every table re-renders with the latest state.
          await fetchPriorevidence();

          Swal.fire({
            icon: 'success',
            title: 'Uploaded!',
            text: 'Certificate uploaded successfully.',
            timer: 1800,
            showConfirmButton: false,
          });
        } catch (err) {
          console.error('Upload failed:', err);
          Swal.fire({ icon: 'error', title: 'Upload failed', text: 'Could not upload the certificate. Please try again.' });
        } finally {
          $btn.prop('disabled', false).text(originalLabel);
        }
      });
      input.trigger('click');
    });

  }, [ongoingTests, completedTests]);

  // ── NEW: separate effect so passed-not-joined table re-renders when its data changes
  useEffect(() => {
    renderPassedNotJoinedTable(passedNotJoinedRef.current, passedNotJoinedTests);
  }, [passedNotJoinedTests]);

  // ─────────────────────────────────────────────────────────────────────────
  // JSX
  // ─────────────────────────────────────────────────────────────────────────
  return (
    <div className="content container-fluid">
      <div className="container mt-4">
        <div className="profile-section">

          {/* ── Ongoing Tests ─────────────────────────────────────────────── */}
          <div className="list mb-5">
            <center><h4><b>Ongoing Prior Evidence</b></h4></center>

            {selectedCandidates.length > 0 && (
              <div className="mb-2 text-end">
                <button className="btn btn-success" onClick={handleSendMail}>
                  Send Prior-Evidence Mail ({selectedCandidates.length})
                </button>
              </div>
            )}

            <div className="col-12" style={{ overflow: 'auto' }}>
              <table
                ref={ongoingRef}
                className="table table-striped table-bordered"
                style={{ width: '100%' }}
              >
                <thead>
                  <tr>
                    <th>Sr.No</th><th>Date</th><th>Name</th><th>Mobile No</th>
                    <th>Email</th><th>Document</th><th>Result</th>
                    <th>Generate</th><th>Certificate</th><th>View Certificate</th><th>Send Mail</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>

          <hr />

          {/* ── NEW: Passed — Not Yet a Member ────────────────────────────── */}
          <div className="list mb-5">

            {/* Section header */}
            <div
              className="d-flex align-items-center justify-content-between mb-3 px-3 py-2"
              style={{
                background: '#fffbeb',
                border: '1px solid #d97706',
                borderRadius: '10px',
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: 24 }}>🏅</span>
                <div>
                  <h5 className="mb-0 fw-bold" style={{ color: '#d97706' }}>
                    Passed Prior Evidence — Membership Pending
                  </h5>
                  <small className="text-muted">
                    These candidates passed the prior evidence test but have not yet joined as members.
                    Select them and send a joining invitation mail.
                  </small>
                </div>
              </div>

              {/* Send Joining Mail button — shown only when candidates are selected */}
              {selectedJoinCandidates.length > 0 && (
                <button
                  className="btn btn-warning fw-semibold"
                  style={{ minWidth: 200, whiteSpace: 'nowrap' }}
                  onClick={handleSendJoiningMail}
                >
                  ✉ Send Joining Mail ({selectedJoinCandidates.length})
                </button>
              )}
            </div>

            <div className="col-12" style={{ overflow: 'auto' }}>
              <table
                ref={passedNotJoinedRef}
                className="table table-striped table-bordered"
                style={{ width: '100%' }}
              >
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>Pass Date</th>
                    <th>Name</th>
                    <th>Mobile No</th>
                    <th>Email</th>
                    <th>Result</th>
                    <th>Send Joining Mail</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

            {/* Empty state */}
            {passedNotJoinedTests.length === 0 && (
              <div
                className="text-center py-4 text-muted"
                style={{ fontSize: 14 }}
              >
                ✓ No pending membership candidates at this time.
              </div>
            )}
          </div>
          {/* ── END Passed Not Joined ─────────────────────────────────────── */}

          <hr />

          {/* ── Completed Tests ───────────────────────────────────────────── */}
          <div className="list mb-5">
            <center><h4><b>Completed Prior Evidence</b></h4></center>
            <div className="col-12" style={{ overflow: 'auto' }}>
              <table
                ref={completedRef}
                className="table table-striped table-bordered"
                style={{ width: '100%' }}
              >
                <thead>
                  <tr>
                    <th>Sr.No</th><th>Date</th><th>Name</th><th>Mobile No</th>
                    <th>Email</th><th>Document</th><th>Result</th>
                    <th>Generate</th><th>Certificate</th><th>View Certificate</th><th>Send Mail</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>

          <hr />

          

        </div>
      </div>
    </div>
  );
};

export default PriorEvidence;